module.exports = __webpack_public_path__ + "img/tutorial-f00-01.eab497df.png";